module.exports = __webpack_public_path__ + "media/images/photos/19-1bcd05aeb8b45baac28512dd4188e99d.jpg";